(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rolves-header-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rolves-navigation')) {
    customElements.define('rolves-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
        this.desktopQuery = window.matchMedia('(min-width: 990px)');
        this.items = [...this.querySelectorAll('[data-rv-item]')];
        this.items.forEach(item => {
          const details = item.querySelector('.rv-disclosure');
          if (!details) {
            item.addEventListener('pointerenter', () => { if (this.hoverQuery.matches) this.closeAll(); }, options);
            return;
          }
          const link = item.querySelector('.rv-navigation-link');
          item.addEventListener('pointerenter', () => {
            if (!this.hoverQuery.matches) return;
            clearTimeout(this.closeTimer);
            clearTimeout(this.openTimer);
            this.openTimer = setTimeout(() => { this.closeAll(details); details.open = true; link.setAttribute('aria-expanded', 'true'); }, 90);
          }, options);
          item.addEventListener('pointerleave', () => {
            if (!this.hoverQuery.matches) return;
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => {
              if (!item.contains(document.activeElement)) { details.open = false; link.setAttribute('aria-expanded', 'false'); }
            }, 160);
          }, options);
          details.addEventListener('toggle', () => {
            if (details.open) this.closeAll(details);
            link.setAttribute('aria-expanded', String(details.open));
          }, options);
          link.addEventListener('click', event => {
            if (this.desktopQuery.matches && !this.hoverQuery.matches && !details.open) {
              event.preventDefault(); this.closeAll(details); details.open = true;
            }
          }, options);
          link.addEventListener('keydown', event => {
            if (event.key === 'ArrowDown') {
              event.preventDefault(); this.closeAll(details); details.open = true;
              details.querySelector('.rv-panel a')?.focus();
            }
          }, options);
          item.addEventListener('focusout', () => {
            queueMicrotask(() => {
              if (!item.contains(document.activeElement) && !item.matches(':hover')) { details.open = false; link.setAttribute('aria-expanded', 'false'); }
            });
          }, options);
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const openItem = this.items.find(item => item.querySelector('.rv-disclosure[open]'));
          if (openItem) { event.preventDefault(); this.closeAll(); openItem.querySelector('.rv-navigation-link').focus(); }
        }, options);
        this.querySelector('.rv-menu-backdrop').addEventListener('pointerenter', () => this.closeAll(), options);
        this.querySelector('.rv-menu-backdrop').addEventListener('click', () => this.closeAll(), options);
        this.querySelector('.header__search').addEventListener('pointerenter', () => { if (this.hoverQuery.matches) this.closeAll(); }, options);
        this.closest('.rolves-header').addEventListener('pointerleave', () => {
          if (this.hoverQuery.matches && !this.contains(document.activeElement)) this.closeAll();
        }, options);
        this.desktopQuery.addEventListener('change', () => this.closeAll(), options);
        window.addEventListener('scroll', () => this.closeAll(), { passive: true, signal: this.controller.signal });
      }
      closeAll(except) {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        this.items.forEach(item => {
          const details = item.querySelector('.rv-disclosure');
          if (details && details !== except) { details.open = false; item.querySelector('.rv-navigation-link').setAttribute('aria-expanded', 'false'); }
        });
      }
      disconnectedCallback() { this.closeAll(); this.controller.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
